'use strict';

var SignificantPosFactory = function SignificantPosFactory(MarketShare) {
  /**
   * Create significant POS instance
   * @param {Object} [pos]
   * @param {string} pos.priority
   * @param {string} pos.country
   * @param {string} pos.city
   * @param {string} pos.iataFrom
   * @param {string} pos.iataTo
   * @param {string} pos.sponsor
   * @param {string} pos.spos
   * @param {MarketShare} pos.marketShare
   * @param {string} pos.assignee
   * @constructor
   */
  function SignificantPos(pos) {
    this.country = pos.country || '';
    this.city = pos.city || '';
    this.iataFrom = pos.iataStart || '';
    this.iataTo = pos.iataEnd || '';
    this.priority = pos.priority || '';
    this.spos = pos.spos || 'Default';
    this.sponsor = pos.sponsor || '';
    this.marketShare = pos.marketShare || new MarketShare(pos.hostShare);
    this.assignee = pos.assignee || '';
  }
  return SignificantPos;
};
SignificantPosFactory.$inject = ['MarketShareFactory'];
module.exports = SignificantPosFactory;